import { ChartColumn, ListClock, MessagesSquare, Waypoints } from "lucide-react"
import { Link, useLocation } from "wouter"

import {
  Sidebar,
  SidebarHeader,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
  useSidebar,
} from "@/components/ui/sidebar"

const items = [
  { path: "/stats", title: "Stats", icon: ChartColumn },
  { path: "/logs", title: "Logs", icon: ListClock },
  { path: "/sessions", title: "Sessions", icon: MessagesSquare },
]

export const crumbs = (path: string): { title: string; href?: string }[] => {
  const detail = path.match(/^\/sessions\/(.+)$/)
  if (detail) {
    const item = items.find((i) => i.path === "/sessions")!
    return [{ title: item.title, href: item.path }, { title: detail[1] }]
  }
  const item = items.find((i) => path.startsWith(i.path))
  return item ? [{ title: item.title }] : []
}

export function AppSidebar() {
  const [location] = useLocation()
  const { isMobile, setOpenMobile } = useSidebar()

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" className="pointer-events-none">
              <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
                <Waypoints />
              </div>
              <span className="text-base font-semibold">LLM Gateway</span>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              {items.map((item) => (
                <SidebarMenuItem key={item.path}>
                  <SidebarMenuButton
                    render={
                      <Link
                        href={item.path}
                        onClick={() => {
                          if (isMobile) {
                            setOpenMobile(false)
                          }
                        }}
                      />
                    }
                    isActive={location.startsWith(item.path)}
                    tooltip={item.title}
                  >
                    <item.icon />
                    <span>{item.title}</span>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarRail />
    </Sidebar>
  )
}
